<template>
  <jin-nang-buy-or-sale :isSell="isSell"></jin-nang-buy-or-sale>
</template>

<script>
import JinNangBuyOrSale from './JinNangBuyOrSale'

export default {
  name: '',
  components: { JinNangBuyOrSale },
  data() {
    return {
      isSell: false
    }
  }
}
</script>
